import axios from "axios";
import { ref } from "vue";
import * as authApi from "@/api/authApi";
import * as cmUtil from "@/utils/cmUtil.js";

const appMode = process.env.VUE_APP_MODE;
const baseUrl = appMode === "local" ? process.env.VUE_APP_API_BASE_URL : "";
let loginFailCnt = 0;

const LOGIN_PAGE_URL = "/paintpro/login";

const ERR_400_MSG = "잘못된 요청입니다.\n계속하시려면 다시 로그인해 주세요.";

const ERR_401_MSG =
  "장시간 활동이 없어 보안을 위해 자동 로그아웃되었습니다.\n계속하시려면 다시 로그인해 주세요.";

const ERR_403_MSG =
  "장시간 활동이 없어 보안을 위해 자동 로그아웃되었습니다.\n계속하시려면 다시 로그인해 주세요.";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
  timeout: 60000,
});

api.ing = ref(false);

api.interceptors.request.use(
  (config) => {
    api.ing.value = true;
    let token = cmUtil.getLocalStorage("token") || "";
    token = token === null || token === "null" ? "" : "Bearer " + token;
    config.headers.Authorization = token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    const status = response.status;
    let resultCode = response?.data?.resultCode;
    let message = response?.data?.message;
    api.ing.value = false;
    if (!(status >= 200 && status <= 210)) {
      if (response.config.url.includes("login/confirm")) {
        return response.data;
      }
      return Promise.reject(response.data.error);
    } else {
      if (!cmUtil.checkApiError(response, resultCode, message)) {
        return false;
      }
      if (resultCode === 411 && message?.length > 5) {
        cmUtil.toast(message, {
          type: "basket",
        });
      } else if (resultCode === 412 && message?.length > 5) {
        cmUtil.toast(message, {
          type: "basket",
        });
      }
    }
    return response.data;
  },
  async (error) => {
    api.ing.value = false;
    const status = error?.response?.status;
    let resultCode = error.response?.data?.resultCode;
    let message = error.response?.data?.message;

    if (status === 400) {
      loginFailCnt++;
      if (loginFailCnt == 1) {
        if (!["/", "/paintpro/login"].includes(location.pathname)) {
          alert(`${ERR_400_MSG}`);
        }
        cmUtil.resetToken();
        location.href = LOGIN_PAGE_URL;
        return false;
      }
    }
    // 401 : Unauthorized : 인증실패
    else if (status === 401) {
      loginFailCnt++;
      if (loginFailCnt == 1) {
        if (!["/", "/paintpro/login"].includes(location.pathname)) {
          alert(`${ERR_401_MSG}`);
        }
        cmUtil.resetToken();
        location.href = LOGIN_PAGE_URL;
        return false;
      }
    }
    // 403 : Forbidden : 권한거부
    else if (status === 403) {
      loginFailCnt++;
      if (loginFailCnt == 1) {
        if (!["/", "/paintpro/login"].includes(location.pathname)) {
          alert(`${ERR_403_MSG}.`);
        }
        cmUtil.resetToken();
        authApi.logout();
        location.href = LOGIN_PAGE_URL;
        return false;
      }
    } else if (error?.code === "ERR_NETWORK") {
      location.href =
        "/paintpro/error/error500?status=" +
        (error.status || "") +
        "&code=" +
        (error?.code || "") +
        "&status=" +
        status +
        "&resultCode=" +
        resultCode +
        "&message=" +
        message +
        "&pagePath=" +
        location.href;
      return false;
    } else {
      location.href =
        "/paintpro/error/error500?status=" +
        (error.status || "") +
        "&code=" +
        (error?.code || "") +
        "&status=" +
        status +
        "&resultCode=" +
        resultCode +
        "&message=" +
        message +
        "&pagePath=" +
        location.href;
      return false;
    }
    return Promise.reject(error);
  }
);

export { api };
